module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-view--no-margin"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.loading) ? [(_vm.$breakpoints.mdUp) ? _c('sk-container', [_c('div', {
    staticClass: "pos-rel"
  }, [_c('sk-google-ad', {
    ref: "googleAdLeft",
    staticClass: "lefty",
    attrs: {
      "advert-id": _vm.googleAds[_vm.googleAdType].left,
      "width": 280,
      "height": 800
    }
  }), _vm._v(" "), _c('sk-google-ad', {
    ref: "googleAdRight",
    staticClass: "righty",
    attrs: {
      "advert-id": _vm.googleAds[_vm.googleAdType].right,
      "width": 280,
      "height": 800
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.featuredData) ? _c('sk-carousel', {
    ref: "featureCarousel",
    staticClass: "feature-carousel",
    attrs: {
      "pageMarkers": "",
      "auto-advance": true
    }
  }, [_vm._l((_vm.featuredData.filter(function (f) { return f.appears_in === 'BOTH' || (f.appears_in === (_vm.isNouveau ? 'NOUVEAU' : 'SK CLASSIC')); })), function(feature) {
    return _c('div', {
      key: feature.title,
      staticClass: "slide",
      attrs: {
        "slot": "slides"
      },
      slot: "slides"
    }, [(feature.ad_tag == undefined || feature.ad_tag == null || feature.ad_tag.length == 0) ? [_c('div', {
      staticClass: "feature-movie"
    }, [(feature.movie) ? _c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs12": "",
        "sm4": "",
        "md3": ""
      }
    }, [(feature.button_1_text && feature.button_1_url) ? _c('sk-button', {
      attrs: {
        "href": feature.button_1_url
      }
    }, [_c('img', {
      staticClass: "img-responsive feature-movie__poster",
      attrs: {
        "src": feature.movie.poster,
        "alt": "feature.movie.title"
      }
    })]) : ((feature.movie && feature.movie.id)) ? _c('sk-button', {
      attrs: {
        "router": "",
        "to": {
          name: 'details_title',
          params: {
            id: feature.movie.id,
            title: feature.movie.title_slug
          }
        }
      }
    }, [_c('img', {
      staticClass: "img-responsive feature-movie__poster",
      attrs: {
        "src": feature.movie.poster,
        "alt": "feature.movie.title"
      }
    })]) : _vm._e()], 1), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs12": "",
        "sm8": "",
        "md9": ""
      }
    }, [_c('div', {
      staticClass: "feature-movie-description"
    }, [(feature.logo_image) ? _c('div', {
      staticClass: "feature__experience-type"
    }, [_c('img', {
      staticClass: "img-responsive-height",
      attrs: {
        "src": feature.logo_image,
        "alt": feature.title
      }
    })]) : _vm._e(), _vm._v(" "), (feature.dont_display_title != '1') ? _c('h2', {
      staticClass: "h1 feature-movie-description--title",
      domProps: {
        "innerHTML": _vm._s(feature.title)
      }
    }) : _vm._e(), _vm._v(" "), (feature.strapline) ? [_c('h3', {
      domProps: {
        "innerHTML": _vm._s(feature.strapline)
      }
    })] : [_c('h3', {
      domProps: {
        "innerHTML": _vm._s(feature.banner_category)
      }
    })], _vm._v(" "), (!_vm.$breakpoints.xs) ? _c('div', {
      domProps: {
        "innerHTML": _vm._s(feature.description)
      }
    }) : _vm._e()], 2), _vm._v(" "), _c('ul', {
      staticClass: "feature-buttons"
    }, [(feature.button_1_text || (feature.movie && feature.movie.id)) ? _c('li', [(feature.button_1_text && feature.button_1_url) ? _c('sk-button', {
      attrs: {
        "primary": "",
        "target": feature.button_1_external_url ? '_blank' : '',
        "tag": "a",
        "href": feature.button_1_url.replace(/amp;/g, '')
      }
    }, [_vm._v("\n                      " + _vm._s(feature.button_1_text) + "\n                    ")]) : ((feature.movie && feature.movie.id)) ? _c('sk-button', {
      attrs: {
        "primary": "",
        "router": "",
        "to": {
          name: 'details_title',
          params: {
            id: feature.movie.id,
            title: feature.movie.title_slug
          }
        }
      }
    }, [_vm._v("\n                      Book now\n                    ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (feature.button_2_text || (feature.movie && feature.movie.id)) ? _c('li', [(feature.button_2_text && feature.button_2_url) ? _c('sk-button', {
      attrs: {
        "tertiary": "",
        "target": feature.button_2_external_url ? '_blank' : '',
        "tag": "a",
        "href": feature.button_2_url.replace(/amp;/g, '')
      }
    }, [_vm._v("\n                      " + _vm._s(feature.button_2_text) + "\n                    ")]) : ((feature.movie && feature.movie.id && feature.add_trailer != 0)) ? _c('sk-button', {
      attrs: {
        "tertiary": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.openVideoDialog(feature.movie.youtube_id)
        }
      }
    }, [(feature.add_trailer === '1') ? _c('sk-icon', {
      attrs: {
        "play-button": ""
      }
    }) : _vm._e(), _vm._v("Play trailer\n                    ")], 1) : _vm._e()], 1) : _vm._e()])])], 1) : [_c('div', {
      staticClass: "feature-movie-description"
    }, [(feature.logo_image) ? _c('div', {
      staticClass: "feature__experience-type"
    }, [_c('img', {
      staticClass: "img-responsive-height",
      attrs: {
        "src": feature.logo_image,
        "alt": feature.title
      }
    })]) : _vm._e(), _vm._v(" "), (feature.dont_display_title == 0) ? _c('h2', {
      staticClass: "h1 feature-movie-description--title",
      domProps: {
        "innerHTML": _vm._s(feature.title)
      }
    }) : _vm._e(), _vm._v(" "), (feature.strapline) ? [_c('h3', {
      domProps: {
        "innerHTML": _vm._s(feature.strapline)
      }
    })] : [_c('h3', {
      domProps: {
        "innerHTML": _vm._s(feature.banner_category)
      }
    })], _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(feature.description)
      }
    })], 2), _vm._v(" "), _c('ul', {
      staticClass: "feature-buttons"
    }, [(feature.button_1_text) ? _c('li', [(feature.button_1_text && feature.button_1_url) ? _c('sk-button', {
      attrs: {
        "primary": "",
        "target": feature.button_1_external_url ? '_blank' : '',
        "tag": "a",
        "href": feature.button_1_url.replace(/amp;/g, '')
      }
    }, [_vm._v("\n                    " + _vm._s(feature.button_1_text) + "\n                  ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (feature.button_2_text) ? _c('li', [(feature.button_2_text && feature.button_2_url) ? _c('sk-button', {
      attrs: {
        "tertiary": "",
        "target": feature.button_2_external_url ? '_blank' : '',
        "tag": "a",
        "href": feature.button_2_url.replace(/amp;/g, '')
      }
    }, [_vm._v("\n                    " + _vm._s(feature.button_2_text) + "\n                  ")]) : _vm._e()], 1) : _vm._e()])]], 2), _vm._v(" "), _c('div', {
      staticClass: "feature-movie-img"
    }, [_c('img', {
      staticClass: "obejct-fit-polyfill",
      attrs: {
        "src": _vm.$breakpoints.xs ? feature.mobile_image : feature.image
      }
    })])] : [_c('sk-google-ad', {
      attrs: {
        "advert-id": _vm.$breakpoints.xs ? feature.ad_tag_mobile : feature.ad_tag,
        "width": _vm.$breakpoints.xs ? 750 : 1920,
        "height": _vm.$breakpoints.xs ? 400 : 640
      }
    })]], 2)
  }), _vm._v(" "), (!_vm.$breakpoints.xs) ? _c('div', {
    staticClass: "move-down",
    attrs: {
      "slot": "footer"
    },
    on: {
      "click": _vm.scrollDown
    },
    slot: "footer"
  }) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('sk-panel', {
    staticClass: "text-center",
    attrs: {
      "transparent": ""
    }
  }, [(_vm.$breakpoints.mdUp) ? _c('sk-google-ad', {
    attrs: {
      "advert-id": _vm.googleAds[_vm.googleAdType].topLg,
      "width": 728,
      "height": 90
    }
  }) : _c('sk-google-ad', {
    attrs: {
      "advert-id": _vm.googleAds[_vm.googleAdType].top,
      "width": 320,
      "height": 50
    }
  })], 1), _vm._v(" "), _c('sk-video', {
    staticClass: "dialog-video",
    attrs: {
      "content": _vm.dialogData
    },
    model: {
      value: (_vm.activeDialog),
      callback: function($$v) {
        _vm.activeDialog = $$v
      },
      expression: "activeDialog"
    }
  }), _vm._v(" "), _c('section', {
    attrs: {
      "id": "filter"
    }
  }, [_c('div', {
    staticClass: "container filter border--darken-2"
  }, [_c('sk-search-filter', {
    ref: "search_filter",
    staticClass: "search-filter",
    attrs: {
      "available-cinemas": _vm.availableCinemas,
      "cinemasByRegion": _vm.cinemasByRegion,
      "predictiveText": _vm.predictiveText,
      "timeRanges": _vm.timeRanges,
      "loading": _vm.loading,
      "cinemaTypes": _vm.cinemaTypes,
      "movieGenres": _vm.movieGenres,
      "filterOptions": _vm.filterOptions,
      "searchResultCount": _vm.searchResultCount,
      "form_data": _vm.form_data,
      "doSearch": _vm.doSearch,
      "search_filter": _vm.filter,
      "isNouveau": _vm.isNouveau
    },
    on: {
      "changed": _vm.getFilteredMovies,
      "cinemaOptions": _vm.setCinemaOptions,
      "timeOptions": _vm.setTimeOptions,
      "typeOptions": _vm.setCinemaTypeOptions,
      "genreOptions": _vm.setGenreOptions,
      "filterOptions": _vm.setFilterOptions,
      "summaryOptions": _vm.summaryOptions,
      "setIsLoading": _vm.setLoading,
      "setCinemaTypeGroups": _vm.setCinemaTypeGroups,
      "setCinemasNearby": _vm.setCinemasNearby
    }
  })], 1)]), _vm._v(" "), _c('section', {
    staticClass: "container movie-listing"
  }, [(_vm.movies) ? _c('div', [_c('sk-layout', {
    staticClass: "movie-listing__tabs",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs6": "",
      "sm5": "",
      "md3": "",
      "lg2": ""
    }
  }, [_c('sk-list-tile', {
    attrs: {
      "value": _vm.tabNowShowing == true
    }
  }, [_c('h4', {
    staticClass: "tab-heading",
    on: {
      "click": function($event) {
        _vm.setVisibleTab('now-showing')
      }
    }
  }, [_vm._v("\n                  Now Showing (" + _vm._s(_vm.countNS) + ")\n                ")])])], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs6": "",
      "sm4": "",
      "md3": "",
      "lg2": ""
    }
  }, [_c('sk-list-tile', {
    attrs: {
      "value": _vm.tabComingSoon == true
    }
  }, [_c('h4', {
    staticClass: "tab-heading",
    on: {
      "click": function($event) {
        _vm.setVisibleTab('coming-soon')
      }
    }
  }, [_vm._v("\n                  Coming Soon (" + _vm._s(_vm.countCS) + ")\n                ")])])], 1)], 1), _vm._v(" "), _c('sk-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabNowShowing && _vm.movies.now_showing),
      expression: "tabNowShowing && movies.now_showing"
    }],
    staticClass: "movie-listing__list",
    class: (_vm.activeMovie ? 'movie-listing__list--active' : ''),
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._l((_vm.movies.now_showing), function(movie, index) {
    return (_vm.movies.now_showing) ? [(_vm.showLoadMoreNowShowing) ? [(index < _vm.loadMoreLimitNowShowing) ? [_c('sk-flex', {
      key: movie.id,
      attrs: {
        "xs6": "",
        "sm3": "",
        "md2": "",
        "lg2": ""
      }
    }, [_c('sk-list-tile', {
      ref: "movie",
      refInFor: true,
      attrs: {
        "value": _vm.activeMovie == movie
      }
    }, [(_vm.movies && _vm.movies.now_showing) ? _c('sk-movie-thumbnail', {
      directives: [{
        name: "observe-visibility",
        rawName: "v-observe-visibility",
        value: (function (isVisible, entry) { return _vm.visibilityChanged(isVisible, entry, movie); }),
        expression: "(isVisible, entry) => visibilityChanged(isVisible, entry, movie)"
      }],
      style: ({
        marginBottom: _vm.activeMovie == movie ? _vm.bottomOffset : ''
      }),
      attrs: {
        "now-showing": "",
        "content": movie
      },
      nativeOn: {
        "click": function($event) {
          _vm.showMovieDetail(movie, $event.currentTarget)
        }
      }
    }) : _vm._e()], 1)], 1), _vm._v(" "), (movie.hasPromos) ? _c('sk-flex', {
      attrs: {
        "xs12": "",
        "sm6": "",
        "md4": "",
        "lg4": ""
      }
    }, [
      [_c('router-link', {
        staticClass: "movie-listing__promo",
        attrs: {
          "to": {
            path: '/promotion/' + movie.promoMeta.nid
          }
        }
      }, [_c('img', {
        staticClass: "movie-thumbnail__img img-responsive",
        attrs: {
          "src": movie.images.promo.desktop.url
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "movie-thumbnail__caption"
      }, [_vm._t("caption", [_c('h5', {
        staticClass: "movie-thumbnail__title",
        domProps: {
          "innerHTML": _vm._s(movie.promoMeta.title)
        }
      }), _vm._v(" "), _c('ul', {
        staticClass: "movie-thumbnail__subtitle"
      }, [_c('li', [_vm._v(_vm._s(_vm._f("truncate")(movie.promoMeta.strapline, 60, '...')))])])]), _vm._v(" "), _c('span', {
        staticClass: "movie-listing__promo--cta"
      }, [_vm._v("Learn More")])], 2)])]
    ], 2) : _vm._e()] : _vm._e()] : [_c('sk-flex', {
      key: movie.id,
      attrs: {
        "xs6": "",
        "sm3": "",
        "md2": "",
        "lg2": ""
      }
    }, [_c('sk-list-tile', {
      ref: "movie",
      refInFor: true,
      attrs: {
        "value": _vm.activeMovie == movie
      }
    }, [(_vm.movies && _vm.movies.now_showing) ? _c('sk-movie-thumbnail', {
      directives: [{
        name: "observe-visibility",
        rawName: "v-observe-visibility",
        value: (function (isVisible, entry) { return _vm.visibilityChanged(isVisible, entry, movie); }),
        expression: "(isVisible, entry) => visibilityChanged(isVisible, entry, movie)"
      }],
      style: ({
        marginBottom: _vm.activeMovie == movie ? _vm.bottomOffset : ''
      }),
      attrs: {
        "now-showing": "",
        "content": movie
      },
      nativeOn: {
        "click": function($event) {
          _vm.showMovieDetail(movie, $event.currentTarget)
        }
      }
    }) : _vm._e()], 1)], 1), _vm._v(" "), (movie.hasPromos) ? _c('sk-flex', {
      attrs: {
        "xs12": "",
        "sm6": "",
        "md4": "",
        "lg4": ""
      }
    }, [
      [_c('router-link', {
        staticClass: "movie-listing__promo",
        attrs: {
          "to": {
            path: '/promotion/' + movie.promoMeta.nid
          }
        }
      }, [_c('img', {
        staticClass: "movie-thumbnail__img img-responsive",
        attrs: {
          "alt": movie.images.promo.desktop.alt,
          "src": movie.images.promo.desktop.url
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "movie-thumbnail__caption"
      }, [_vm._t("caption", [_c('h5', {
        staticClass: "movie-thumbnail__title",
        domProps: {
          "innerHTML": _vm._s(movie.promoMeta.title)
        }
      }), _vm._v(" "), _c('ul', {
        staticClass: "movie-thumbnail__subtitle"
      }, [_c('li', [_vm._v(_vm._s(_vm._f("truncate")(movie.promoMeta.strapline, 60, '...')))])])]), _vm._v(" "), _c('span', {
        staticClass: "movie-listing__promo--cta"
      }, [_vm._v("Learn More")])], 2)])]
    ], 2) : _vm._e()]] : _vm._e()
  }), _vm._v(" "), (_vm.movies.now_showing.length <= 0) ? [_c('sk-panel', [_vm._v("\n                Sorry! We don't seem to have the movie you're looking for. Check for more movies in Coming Soon.\n              ")])] : _vm._e(), _vm._v(" "), (_vm.showLoadMoreNowShowing && _vm.movies.now_showing.length > 10) ? _c('sk-flex', {
    attrs: {
      "xs12": "",
      "text-center": ""
    }
  }, [_c('sk-button', {
    attrs: {
      "block": _vm.$breakpoints.xs,
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.doLoadMoreNowShowing(_vm.movies.now_showing.length)
      }
    }
  }, [_vm._v("Load More")])], 1) : _vm._e()], 2), _vm._v(" "), _c('sk-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabComingSoon),
      expression: "tabComingSoon"
    }],
    staticClass: "movie-listing__list",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._l((_vm.movies.coming_soon), function(movie, index) {
    return (_vm.movies.coming_soon) ? [(_vm.showLoadMoreComingSoon) ? [(index < _vm.loadMoreLimitComingSoon) ? [_c('sk-flex', {
      key: movie.id,
      attrs: {
        "xs6": "",
        "sm3": "",
        "md2": "",
        "lg2": ""
      }
    }, [_c('sk-list-tile', {
      ref: "movie",
      refInFor: true,
      attrs: {
        "value": _vm.activeMovie == movie
      }
    }, [(_vm.movies.coming_soon && movie != undefined && movie != null && (typeof movie == 'object')) ? _c('sk-movie-thumbnail', {
      directives: [{
        name: "observe-visibility",
        rawName: "v-observe-visibility",
        value: (function (isVisible, entry) { return _vm.visibilityChanged(isVisible, entry, movie); }),
        expression: "(isVisible, entry) => visibilityChanged(isVisible, entry, movie)"
      }],
      style: ({
        marginBottom: _vm.activeMovie == movie ? _vm.bottomOffset : ''
      }),
      attrs: {
        "coming-soon": "",
        "content": movie
      },
      nativeOn: {
        "click": function($event) {
          _vm.showMovieDetail(movie, $event.currentTarget)
        }
      }
    }, [(movie.opening_date != undefined && movie.opening_date != null) ? _c('div', {
      staticClass: "movie-thumbnail__subtitle",
      attrs: {
        "slot": "caption"
      },
      slot: "caption"
    }, [(movie.has_sessions_available) ? _c('div', {
      staticStyle: {
        "width": "95%",
        "padding": "5px",
        "margin": "10px auto",
        "background-color": "#0089d0",
        "color": "#ffffff",
        "text-align": "center"
      }
    }, [_vm._v("\n                            PRE-BOOK NOW\n                          ")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticStyle: {
        "padding": "0px 5px",
        "font-size": "10px"
      }
    }, [_vm._v("\n                            Releases " + _vm._s(movie.opening_date.additional.day) + " " + _vm._s(movie.opening_date.additional.string_long_month) + "\n                          ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-weight": "bold",
        "padding": "0px 5px",
        "float": "left",
        "width": "100%"
      }
    }, [_vm._v(_vm._s(movie.title))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('ul', {
      staticClass: "movie-thumbnail__subtitle",
      staticStyle: {
        "padding": "0px 5px"
      }
    }, _vm._l((movie.genres), function(genre) {
      return _c('li', [_vm._v(_vm._s(genre.name.toLowerCase()))])
    }))]) : _vm._e()]) : _vm._e()], 1)], 1), _vm._v(" "), (movie.hasPromos) ? _c('sk-flex', {
      attrs: {
        "xs12": "",
        "sm6": "",
        "md4": "",
        "lg4": ""
      }
    }, [
      [_c('router-link', {
        attrs: {
          "to": {
            path: '/promotion/' + movie.promoMeta.nid
          }
        }
      }, [_c('img', {
        staticClass: "movie-thumbnail__img",
        attrs: {
          "alt": movie.images.promo.desktop.alt,
          "src": movie.images.promo.desktop.url
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "movie-thumbnail__caption"
      }, [_vm._t("caption", [_c('h5', {
        staticClass: "movie-thumbnail__title"
      }, [_vm._v(_vm._s(movie.promoMeta.title))]), _vm._v(" "), _c('ul', {
        staticClass: "movie-thumbnail__subtitle"
      }, [_c('li', [_vm._v(_vm._s(_vm._f("truncate")(movie.promoMeta.strapline, 60, '...')))])])])], 2)])]
    ], 2) : _vm._e()] : _vm._e()] : [_c('sk-flex', {
      key: movie.id,
      attrs: {
        "xs6": "",
        "sm3": "",
        "md2": "",
        "lg2": ""
      }
    }, [_c('sk-list-tile', {
      ref: "movie",
      refInFor: true,
      attrs: {
        "value": _vm.activeMovie == movie
      }
    }, [(_vm.movies.coming_soon) ? _c('sk-movie-thumbnail', {
      directives: [{
        name: "observe-visibility",
        rawName: "v-observe-visibility",
        value: (function (isVisible, entry) { return _vm.visibilityChanged(isVisible, entry, movie); }),
        expression: "(isVisible, entry) => visibilityChanged(isVisible, entry, movie)"
      }],
      style: ({
        marginBottom: _vm.activeMovie == movie ? _vm.bottomOffset : ''
      }),
      attrs: {
        "coming-soon": "",
        "content": movie
      },
      nativeOn: {
        "click": function($event) {
          _vm.showMovieDetail(movie, $event.currentTarget)
        }
      }
    }, [(movie.opening_date != undefined && movie.opening_date != null) ? _c('div', {
      staticClass: "movie-thumbnail__subtitle",
      attrs: {
        "slot": "caption"
      },
      slot: "caption"
    }, [(movie.has_sessions_available) ? _c('div', {
      staticStyle: {
        "width": "95%",
        "padding": "5px",
        "margin": "10px auto",
        "background-color": "#0089d0",
        "color": "#ffffff",
        "text-align": "center"
      }
    }, [_vm._v("\n                            PRE-BOOK NOW\n                          ")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticStyle: {
        "padding": "0px 5px",
        "font-size": "10px"
      }
    }, [_vm._v("\n                            Releases " + _vm._s(movie.opening_date.additional.day) + " " + _vm._s(movie.opening_date.additional.string_long_month) + "\n                          ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-weight": "bold",
        "padding": "0px 5px",
        "float": "left",
        "width": "100%"
      }
    }, [_vm._v(_vm._s(movie.title))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('ul', {
      staticClass: "movie-thumbnail__subtitle",
      staticStyle: {
        "padding": "0px 5px"
      }
    }, _vm._l((movie.genres), function(genre) {
      return _c('li', [_vm._v(_vm._s(genre.name.toLowerCase()))])
    }))]) : _vm._e()]) : _vm._e()], 1)], 1), _vm._v(" "), (movie.hasPromos) ? _c('sk-flex', {
      attrs: {
        "xs12": "",
        "sm6": "",
        "md4": "",
        "lg4": ""
      }
    }, [
      [_c('router-link', {
        attrs: {
          "to": {
            path: '/promotion/' + movie.promoMeta.nid
          }
        }
      }, [_c('img', {
        staticClass: "movie-thumbnail__img",
        attrs: {
          "alt": movie.images.promo.mobile.alt,
          "src": movie.images.promo.mobile.url
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "movie-thumbnail__caption"
      }, [_vm._t("caption", [_c('h5', {
        staticClass: "movie-thumbnail__title"
      }, [_vm._v(_vm._s(movie.promoMeta.title))]), _vm._v(" "), _c('ul', {
        staticClass: "movie-thumbnail__subtitle"
      }, [_c('li', [_vm._v(_vm._s(_vm._f("truncate")(movie.promoMeta.strapline, 60, '...')))])])])], 2)])]
    ], 2) : _vm._e()]] : _vm._e()
  }), _vm._v(" "), (_vm.movies.coming_soon.length <= 0) ? [_c('sk-panel', [_vm._v("\n                Sorry! We don't seem to have the movie you're looking for. Check for more movies in Now Showing.\n              ")])] : _vm._e(), _vm._v(" "), (_vm.showLoadMoreComingSoon && _vm.movies.coming_soon.length > 2) ? _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-button', {
    attrs: {
      "block": "",
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.doLoadMoreComingSoon(_vm.movies.coming_soon.length)
      }
    }
  }, [_vm._v("Load More")])], 1) : _vm._e()], 2)], 1) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.activeMovie) ? _c('sk-movie-summary', {
    ref: "movie_summary",
    staticClass: "movie-summary",
    attrs: {
      "movie": _vm.activeMovie,
      "cinema_id": _vm.selected_cinema_id,
      "experiences": _vm.selected_experiences,
      "top": _vm.top,
      "cinema_slug": _vm.summary_cinema_slug,
      "selected_types": _vm.summary_types,
      "selected_time": _vm.summary_time
    },
    on: {
      "dialogDataChange": _vm.openVideoDialog
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), (!_vm.previewMode) ? [_c('sk-quick-book', {
    ref: "search_filter",
    attrs: {
      "cinema": _vm.selected_cinema,
      "activeMovie": _vm.activeMovie,
      "filter": _vm.filter,
      "filters": _vm.form_data,
      "doSearch": _vm.doSearch
    }
  })] : void 0, _vm._v(" "), _c('sk-snackbar', {
    staticClass: "homepage__alert",
    attrs: {
      "bottom": "",
      "right": "",
      "fixed": "",
      "timeout": null
    },
    model: {
      value: (_vm.skclubAlert),
      callback: function($$v) {
        _vm.skclubAlert = $$v
      },
      expression: "skclubAlert"
    }
  }, [_c('div', [_c('h3', [_vm._v("Join SK Club Today "), _c('sk-icon', {
    staticClass: "homepage__alert-close",
    attrs: {
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.skclubAlert = false
      }
    }
  })], 1), _vm._v(" "), _c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/loyalty-sk-club.png",
      "alt": "Join SK Club"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Join the SK Club to customise your movie preferences and speed up movie bookings.")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "tertiary": "",
      "router": "",
      "to": {
        path: 'user/signup'
      }
    }
  }, [_vm._v("Join SK Club")])], 1)])] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54dea991","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/home/home.vue
// module id = 516
// module chunks = 0